import {
    useMemo,
} from 'react'
import isEmpty from 'lodash/isEmpty'
import {
    useLoaderData,
    useOutletContext,
} from 'react-router-dom'
import {
    ActionComponentFunction,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import {
    SkyNetLoaderResponse,
    SkyNetDomainFormOutletContext,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.types'

import useStyles from './SkyNetDomainFormWrapper.styles'

export default function SkyNetDomainFormWrapper<Data>({
    component: Component,
}: {
    component: ((props: {
        data?: Data,
        onSuccess?: () => void,
        onCancel?: () => void,
    }) => JSX.Element) | ActionComponentFunction,
}) {
    const {
        classes,
    } = useStyles()
    const {
        data, invalidate,
    }: SkyNetLoaderResponse<Data> = useLoaderData() || {}
    const {
        backPath,
    } = useOutletContext<SkyNetDomainFormOutletContext>()

    const props = useMemo(() => {
        return !isEmpty(data) ? {
            data,
            onCancel: invalidate,
            onSuccess: invalidate,
            onClose: invalidate,
            backPath,
        } : {}
    }, [
        data,
        invalidate,
        backPath,
    ])

    return (
        <div
            className={classes.contentWrapper}
            data-testid="snd-form-wrapper"
        >
            <div className={classes.content}>
                <Component
                    {...props} // eslint-disable-line react/jsx-props-no-spreading
                />
            </div>
        </div>
    )
}
